import React from 'react';
import PropTypes from 'prop-types';

import { testSetEntryType, dictionaryType, intentType } from 'types';
import Entry from './components/Entry';
import './style.scss';

export const TestSetsList = ({
  entries,
  onDeleteEntry,
  onUpdateEntry,
  onAddEntry,
  openIntentAndFeatureView,
  closeIntentAndFeatureView,
  onAddEntryBefore,
  onAddEntryAfter,

  dictionaries,
  isLoadingDictionaries,
  isAddingDictionary,
  onGetDictionaries,
  onAddDictionaryEntry,

  onGetAllIntents,
  intents,
  isLoadingAllIntents,
  onUpdateIntent,
  onGetIntent,
  onGoToIntent,
  onOpenNewIntentModal,
}) => (
  <div styleName="list">
    {entries.map(item => (
      <Entry
        key={item.id}
        closeIntentAndFeatureView={closeIntentAndFeatureView}
        dictionaries={dictionaries}
        entry={item}
        intents={intents}
        isAddingDictionary={isAddingDictionary}
        isLoadingAllIntents={isLoadingAllIntents}
        isLoadingDictionaries={isLoadingDictionaries}
        openIntentAndFeatureView={openIntentAndFeatureView}
        onAddDictionaryEntry={onAddDictionaryEntry}
        onAddEntry={onAddEntry}
        onAddEntryAfter={onAddEntryAfter}
        onAddEntryBefore={onAddEntryBefore}
        onDeleteEntry={onDeleteEntry}
        onGetAllIntents={onGetAllIntents}
        onGetDictionaries={onGetDictionaries}
        onGetIntent={onGetIntent}
        onGoToIntent={onGoToIntent}
        onOpenNewIntentModal={onOpenNewIntentModal}
        onUpdateEntry={onUpdateEntry}
        onUpdateIntent={onUpdateIntent}
      />
    ))}
  </div>
);

TestSetsList.propTypes = {
  /* eslint-disable react/sort-prop-types */
  entries: PropTypes.arrayOf(testSetEntryType).isRequired,
  onDeleteEntry: PropTypes.func,
  onUpdateEntry: PropTypes.func,
  onAddEntry: PropTypes.func,

  openIntentAndFeatureView: PropTypes.func,
  closeIntentAndFeatureView: PropTypes.func,
  onAddEntryBefore: PropTypes.func,
  onAddEntryAfter: PropTypes.func,

  dictionaries: PropTypes.arrayOf(dictionaryType),
  isLoadingDictionaries: PropTypes.bool,
  isAddingDictionary: PropTypes.bool,
  onGetDictionaries: PropTypes.func,
  onAddDictionaryEntry: PropTypes.func,

  onGetAllIntents: PropTypes.func,
  onUpdateIntent: PropTypes.func,
  onGetIntent: PropTypes.func,
  onGoToIntent: PropTypes.func,
  onOpenNewIntentModal: PropTypes.func,
  intents: PropTypes.arrayOf(intentType),
  isLoadingAllIntents: PropTypes.bool,
};

export default TestSetsList;
